import axios from "axios";

export const META_PIXEL_ID = "1982921129086271";
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const cookie = (name) => {
  const found = document.cookie.split("; ").find((x) => x.startsWith(name + "="));
  return found ? decodeURIComponent(found.split("=").slice(1).join("=")) : undefined;
};

/** Fire ViewContent in the browser with the SAME event_id the server used (Meta dedupes browser+server). */
export function trackSignupViewContent(eventId) {
  if (!eventId) return;
  try {
    window.fbq?.("trackSingle", META_PIXEL_ID, "ViewContent", { content_name: "Cadastro concluído", content_category: "signup" }, { eventID: eventId });
  } catch (e) { console.debug("[meta] fbq failed", e?.message); }
  // Hand _fbp/_fbc to the server so the CAPI event carries browser identifiers (better match quality)
  axios.post(`${API}/meta/identifiers`, { event_id: eventId, fbp: cookie("_fbp"), fbc: cookie("_fbc"), source_url: window.location.href }).catch(() => {});
}
